// extracted by mini-css-extract-plugin
export var container = "_mh-0";
export var dotAnimation = "_mh-2";
export var dotsLoading = "_mh-1";